import { darken, lighten } from '@mui/material/styles';
import { brandColors, commonColors, legacyBrandColors, newSystemColors, systemColors } from './shared/palette';

export const palette = {
  mode: 'light' as const,
  contrastThreshold: 3,
  tonalOffset: 0.2,

  common: {
    ...commonColors,
    offWhite: legacyBrandColors.offWhite,
  },

  primary: {
    main: newSystemColors.blue.main,
    // light: '',
    dark: newSystemColors.blue.dark,
    contrastText: commonColors.white,
  },

  secondary: {
    // orange
    main: newSystemColors.blue.main,
    /**
     * light: '',
     * dark: '',
     */
    contrastText: commonColors.white,
  },

  tertiary: {
    // grey
    main: '#aaa',
    /**
     * light: '',
     * dark: '',
     */
    contrastText: commonColors.black,
  },

  action: {
    active: '#939393',
    hover: 'rgba(0, 0, 0, .04)',
    hoverOpacity: 0.1,
    selected: 'rgba(0, 0, 0, .08)',
    selectedOpacity: 0.08,
    disabled: darken('#aaa', 0.25),
    disabledBackground: lighten('#aaa', 0.5),
    disabledOpacity: 0.38,
    focus: newSystemColors.blue.main,
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },

  text: {
    title: newSystemColors.gray1, // very dark grey
    primary: newSystemColors.gray1, // dark grey
    secondary: '#888', // grey
    disabled: '#aaa', // light grey
    hint: '#e0e0e0', // light grey
  },

  background: {
    default: legacyBrandColors.offWhite, // off white
    app: legacyBrandColors.darkBlue, // dark blue
    header: commonColors.white, // white
    nav: legacyBrandColors.darkBlue, // dark blue
    paper: commonColors.white, // white
    unavailable: '#f0f0f0', // grey
  },

  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
  },

  error: {
    // red
    main: systemColors.error,
    light: '#fdeded',
    // dark: '',
    contrastText: darken(systemColors.error, 0.8),
  },

  success: {
    // green
    main: systemColors.success,
    light: lighten(systemColors.success, 0.9),
    // dark: '',
    contrastText: darken(systemColors.success, 0.8),
  },

  warning: {
    // yellow
    main: systemColors.warning,
    light: lighten(systemColors.warning, 0.6),
    // dark: '',
    contrastText: darken(systemColors.warning, 0.8),
  },

  info: {
    // blue
    main: systemColors.info,
    light: lighten(systemColors.info, 0.75),
    // dark: '',
    contrastText: darken(systemColors.info, 0.8),
  },

  positive: {
    // green
    main: systemColors.positive,
    /**
     * light: '',
     * dark: '',
     */
    contrastText: darken(systemColors.positive, 0.8),
  },

  negative: {
    // red
    main: systemColors.negative,
    /**
     * light: '',
     * dark: '',
     */
    contrastText: darken(systemColors.negative, 0.8),
  },

  neutral: {
    // yellow
    main: systemColors.neutral,
    /**
     * light: '',
     * dark: '',
     */
    contrastText: darken(systemColors.neutral, 0.8),
  },

  unknown: {
    // grey
    main: systemColors.unknown,
    /**
     * light: '',
     * dark: '',
     */
    contrastText: darken(systemColors.unknown, 0.8),
  },

  divider: newSystemColors.gray4,

  brandBlue: brandColors.blue,
  brandAqua: brandColors.aqua,
  brandLightAqua: brandColors.lightAqua,
  brandPurple: brandColors.purple,
  brandLightPurple: brandColors.lightPurple,
  brandNeonGreen: brandColors.neonGreen,
  brandOffWhite: brandColors.offWhite,

  white: newSystemColors.white,
  gray6: newSystemColors.gray6,
  gray5: newSystemColors.gray5,
  gray4: newSystemColors.gray4,
  gray3: newSystemColors.gray3,
  gray2: newSystemColors.gray2,
  gray1: newSystemColors.gray1,
  navGray: newSystemColors.navGray,
};
